import { motion } from 'motion/react';

/**
 * AnimatedPage — wraps page content with fade transition.
 *
 * Props:
 *   children  — page content
 *   className — optional container classes
 */
export default function AnimatedPage({ children, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}
